<template>
  <form @submit.prevent="changePassword" class="tab-pane">
    <div class="row form-group m-b-xs">
      <div class="col-xs-3 text-muted">
        Current password
      </div>
      <div class="col-xs-9">
        <input id="currentPassword" name="currentPassword" v-model="params.current_password" :class="{ 'is-invalid': submitted && errors.has('currentPassword') }" v-validate="{required:true}" type="password" class="form-control">
        <span v-if="submitted && errors.has('currentPassword')" class="help-block m-b-none parsley-error-list">{{'Current password is required'}}</span>
      </div>
    </div>
    <div class="row form-group m-b-xs">
      <div class="col-xs-3 text-muted">
        New password
      </div>
      <div class="col-xs-9">
        <input id="newPassword" name="newPassword" :class="{ 'is-invalid': submitted && errors.has('newPassword') }" v-validate="{required:true}" v-model="params.password" type="password" class="form-control">
        <span v-if="submitted && errors.has('newPassword')" class="help-block m-b-none parsley-error-list">{{'New password is required'}}</span>
      </div>
    </div>
    <div class="row form-group m-b-xs">
      <div class="col-xs-3 text-muted">
        Confirm new password
      </div>
      <div class="col-xs-9">
        <input id="confirmPassword" name="confirmPassword" :class="{ 'is-invalid': submitted && errors.has('confirmPassword') }" v-validate="{required:true}" v-model="params.password_confirmation" type="password" class="form-control">
        <span v-if="submitted && errors.has('confirmPassword')" class="help-block m-b-none parsley-error-list">{{'Confirm password is required'}}</span>
      </div>
    </div>
    <div class="row form-group m-b-xs">
      <div class="col-xs-12">
        <button type="submit" class="btn btn-primary pull-right">Change</button>
      </div>
    </div>
  </form>
</template>

<script>
    export default {
        name: "change-password",
        data() {
          return {
            submitted: false,
            params: {
              current_password: '',
              password: '',
              password_confirmation: ''
            },
          }
        },
        methods: {
          changePassword(e) {
            this.submitted = true;
            let url = `${process.env.ACCOUNT_URL}/api/users/me/change-password`;

            this.$validator.validate().then(valid => {
              if(valid) {
                axios['post'](url, this.params, {
                  headers: { Authorization: `Bearer ${window.user.oauth_token}`}
                }).then(res => {
                  // this.$router.back();
                  this.$toaster.success("Successfully changed");
                }).catch((error, a, b) => {
                  if (error.response.status === 422) {
                    let err = '';
                    if(error.response.data.errors.length) {
                      err = error.response.data.errors[0].message;
                    } else {
                      err = error.response.data.message;
                    }
                    this.$toaster.error(err);
                  }
                });
              }
            });

          },
        }
    }
</script>

<style scoped>
  .is-invalid {
    border: 1px solid darkred;
  }
</style>
